import { jsx as _jsx } from "react/jsx-runtime";
import { MenuIcon } from 'components/CustomIcons';
import styles from './style.module.less';
const DashMenuButton = ({ onClick }) => (_jsx("button", { type: "button", "aria-label": "Menu", className: styles.menuButton, onClick: onClick, children: _jsx(MenuIcon, { className: styles.menuIcon }) }));
export default DashMenuButton;
